import { createContext, useContext, useEffect, useState } from "react";
import { RequestError, useApi } from "../services";
import { CompanyData } from "../pages";

export interface UserFuncao {
  id: number;
  funcionario: string;
  barragem: number;
  setor?: string;
  funcao?: string;
}

export interface User {
  id: string;
  nome: string;
  status: boolean;
  email: string;
  funcoes: UserFuncao[];
  empreendimento: string;
  idUpdate?: string;
  insertDate: Date;
  updateDate?: Date;
  telefones?: string;
  admin?: boolean;
  empresa?: CompanyData;
}

const UserContext = createContext({} as User | RequestError | undefined);

export const useUserContext = () => {
  return useContext(UserContext);
};


interface Props {
  children?: React.ReactNode;
}
export const UserProvider: React.FC<Props> = ({ children }) => {
  const api = useApi();
  const [userData, setUserData] = useState<User | RequestError | undefined>(undefined);

  useEffect(() => {
    api.user.getUser().then((user) => {
      if ("error" in user) {
        setUserData(user);
        return;
      }

      api.company.company(user.empreendimento).then((value) => {
        setUserData({ ...user, empresa: "error" in value ? undefined : value });
      });
    });
  }, []);

  return <UserContext.Provider value={userData}>
    {children}
  </UserContext.Provider>;
};
